enum AccessActionTypeEnum {
	Rfid = 'rfid',
	Bluetooth = 'ble',
	Server = 'server',
	Memory = 'memory',
	Schedule = 'schedule',
	ServerScheduled = 'serverScheduled',
	ServerTriggered = 'serverTriggered',
}

export default AccessActionTypeEnum;
